import { useTranslation } from 'next-i18next';
import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

import { RootState } from '../../../../redux/store';
import SellerInformation from '../../../SellerInformation';
import SentModal from '../../SentModal';
import BaseModal from '../BaseModal';
import ShowPhoneFormValues, {
  ShowPhoneFormValuesProps
} from './ShowPhoneFormValues';
import ShowPhoneSubmitButton, {
  ShowPhoneSubmitButtonProps
} from './ShowPhoneSubmitButton';

export type ShowPhoneModalProps = ShowPhoneSubmitButtonProps &
  ShowPhoneFormValuesProps;

const ShowPhoneModal: React.FC<ShowPhoneModalProps> = ({
  onClose,
  onSubmit,
  sellerName,
  sellerLogo,
  sellerPhone
}) => {
  const { t } = useTranslation('property');
  const title = t('showPhone');
  const titleSuccess = t('contactFormTitleSuccessMessage');
  const messageSuccess = t('showPhoneSuccessMessage');
  const secondaryMessageSuccess = t('showPhoneSuccessSecondaryMessage');

  const state = useSelector(
    (state: RootState) => ({
      isShowPhoneFormSent: state.contactForm.isShowPhoneFormSent,
      isMobileModalOpen: state.contactForm.isMobileModalOpen,
      source: state.contactForm.source,
      status: state.contactForm.status
    }),
    shallowEqual
  );

  const isSentModalOpen = React.useMemo(() => {
    return (
      state.isShowPhoneFormSent &&
      state.source === 'showPhone' &&
      state.status !== 'initial'
    );
  }, [state]);

  return (
    <React.Fragment>
      <BaseModal
        isOpen={state.isMobileModalOpen && state.source === 'showPhone'}
        onClose={onClose}
        footer={
          <ShowPhoneSubmitButton
            onClose={onClose}
            onSubmit={onSubmit}
          />
        }
        title={title}
      >
        <ShowPhoneFormValues
          sellerName={sellerName}
          sellerLogo={sellerLogo}
        />
      </BaseModal>
      <SentModal
        headerTitle={title}
        messageI18nKey={messageSuccess}
        secondaryMessageI18nKey={secondaryMessageSuccess}
        titleI18nKey={titleSuccess}
        isOpen={isSentModalOpen}
        sellerName={sellerName}
      >
        <SellerInformation
          sellerLogo={sellerLogo}
          sellerName={sellerName}
          sellerPhone={sellerPhone}
        />
      </SentModal>
    </React.Fragment>
  );
};

export default ShowPhoneModal;
